import { Div } from '../../../base/components/native/div'
import { waitFor } from '../../../base/utils/wait'

export const Loading = () => {

    const base = Div()
    const title = Div('Hold on, we’re <b>calculating</b> pixels... ')
    base.append(title)
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    var dummy = document.createElement('canvas')
    var dummyCtx = dummy.getContext('2d') as CanvasRenderingContext2D
    dummy.width = 50
    dummy.height = 50
    base.el.appendChild(canvas)
    title.cssClass({
        margin: '15px 0',
    })
    base.cssClass({
        overflow: 'hidden',
        height: '600px',
        fontSize: '18px',
        padding: '200px 0 60px',
        textAlign: 'center',
        backgroundColor: '#fff',
        display: 'none',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',

    })

    return Object.assign(base, {
        load () {
            ctx.fillStyle = 'rgb(255, 255, 255)'
            ctx.fillRect(0, 0, 500, 500)
            const background = new Image()
            const RAND = Math.floor(Math.random() * 3)
            background.src = ['/images/car.jpg', '/images/flower.jpg', '/images/apple.jpg'][RAND]
            background.onload = function () {
                dummyCtx.drawImage(background, 0, 0, 50, 50)
                var imgData = dummyCtx.getImageData(0, 0, 50, 50)
                canvas.width = 500
                canvas.height = 500
                var positions: any[] = []
                var clears : any[] = []
                for (var i = 0; i < 50; i++) {
                    for (var j = 0; j < 50; j++) {
                        var red = imgData.data[(i * 50 + j) * 4]
                        var green = imgData.data[(i * 50 + j) * 4 + 1]
                        var blue = imgData.data[(i * 50 + j) * 4 + 2]
                        positions.push({ x: j * 10, y: i * 10, color: {red, green, blue} })
                        clears.push({ x: j * 10, y: i * 10, color: {red: 255, green: 255, blue: 255} })
                        // positions.push({ x: j * 10, y: i * 10 })
                    }
                }
                // Draw rectangles
                function drawNextRectangle() {
                    if (positions.length > 0) {
                        var randomIndex = Math.floor(Math.random() * positions.length)
                        var position = positions[randomIndex]
                        var color = position.color
                        ctx.fillStyle = "rgb(" + color.red + "," + color.green + "," + color.blue + ")"
                        ctx.fillRect(position.x, position.y, 10, 10)
                        positions.splice(randomIndex, 1)
                        setTimeout(drawNextRectangle, 2)
                    } else if (clears.length > 0) {
                        var randomIndex = Math.floor(Math.random() * clears.length)
                        var position = clears[randomIndex]
                        var color = position.color
                        ctx.fillStyle = "rgb(" + color.red + "," + color.green + "," + color.blue + ")"
                        ctx.fillRect(position.x, position.y, 10, 10)
                        clears.splice(randomIndex, 1)
                        setTimeout(drawNextRectangle, 2)
                    }
                }
                drawNextRectangle()
                canvas.style.width = '500px'
                canvas.style.marginTop = '20px'
            }
        }
    })
}